import { isEmpty } from 'lodash';
import moment from 'moment';
import queryString from 'qs';

const getExportReportHostTaskRequest = (filter) => {
  const queries = {};

  if (filter?.search) queries['search'] = filter.search;
  if (filter?.endedAt) queries['endedAt'] = moment(filter.endedAt).format('YYYY-MM-DD');
  if (filter?.startedAt) queries['startedAt'] = moment(filter.startedAt).format('YYYY-MM-DD');
  if (!isEmpty(filter?.brand)) queries['brandName'] = filter?.brand?.value;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getExportReportHostTaskRequest;
